import type { PackStatus } from '../api/types-p3';

/**
 * ランチャーへの出し方。「みんな」か「管理者だけ」の 2 つ（「公開しない」はない）。
 * 新しいサーバーは管理者だけから始まる
 */
export function PackVisibility({
  pack,
  disabled,
  hub,
  onChange,
}: {
  pack: Pick<PackStatus, 'adminOnly'>;
  disabled: boolean;
  /** hub 配下ならその hub（ランチャーの一覧には出ず、ホームページの一覧と入場だけが変わる） */
  hub?: string;
  onChange: (adminOnly: boolean) => void;
}) {
  const adminOnly = pack.adminOnly !== false;
  return (
    <fieldset
      className="stack"
      style={{ border: 0, padding: 0, margin: 0, gap: 4 }}
      data-search-id="launcher-admin-only"
    >
      <legend className="small muted">誰に見せるか</legend>
      <label className="check">
        <input
          type="radio"
          name="pack-visibility"
          checked={adminOnly}
          disabled={disabled}
          onChange={() => onChange(true)}
        />
        管理者だけ（新しいサーバーはここから）
      </label>
      <label className="check">
        <input
          type="radio"
          name="pack-visibility"
          checked={!adminOnly}
          disabled={disabled}
          onChange={() => onChange(false)}
        />
        みんな
      </label>
      <p className="small muted" style={{ margin: 0 }}>
        {hub
          ? `管理者だけのときは、ホームページの一覧に出さず、`
          : 'みんなにすると、Shouchan Launcher の一覧とホームページに出て、誰でも「プレイ」で参加できます。管理者だけのときは、ランチャーでパネルにログインしたオーナー・管理者にだけ「管理者用」の印つきで出て、ホームページにも出しません。また、'}
        許可リストをオンにし、利用者タブで登録したオーナー・管理者の Minecraft
        アカウントを自動で入れます（手で入れた人はそのまま残ります）。
      </p>
    </fieldset>
  );
}
